export default __webpack_public_path__ + "static/media/Blooded Bracers of the Clans.22242e21.jpg";